import React from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import { TelephoneInbound, TelephoneOutbound, Envelope } from "react-bootstrap-icons";
import "../css/Section4.css";

const Section4 = () => {
  return (
    <section className="whatwedo-section">
      <Container>
        <Row>
          {/* LEFT CONTENT */}
          <Col lg={6}>
            <span className="section-label">What we do</span>

            <h2 className="section-title">
              Your growth is our passion
            </h2>

            {/* STATS */}
            <Row className="stats-row">
              <Col md={4}>
                <h3 className="stat-number">1500+</h3>
                <p className="stat-text">Employment Created</p>
              </Col>
              <Col md={4}>
                <h3 className="stat-number">22+</h3>
                <p className="stat-text">Prestigious Clients</p>
              </Col>
              <Col md={4}>
                <h3 className="stat-number">20+</h3>
                <p className="stat-text">Localization Support</p>
              </Col>
            </Row>

            {/* BUTTONS */}
            <div className="btn-group-custom">
              <Button variant="outline-secondary" className="me-3">
                Learn More
              </Button>
              <Button variant="primary">
                Contact Us
              </Button>
            </div>

            {/* FOOT NOTE */}
            <p className="foot-text">
              We create employment in <strong>Metro, Tier 1 and Tier 2</strong>{" "}
              cities 🏙️
            </p>
          </Col>

          {/* RIGHT CONTENT */}
          <Col lg={6} className="timeline">
            <div className="timeline-item">
              <div className="icon-circle">
                <TelephoneInbound />
              </div>
              <div className="timeline-content">
                <h5>Inbound Customer Support</h5>
                <p>
                  Our trained professionals strive to deliver excellent customer
                  service, build rapport, and resolve customer issues seamlessly.
                </p>
              </div>
            </div>

            <div className="timeline-line"></div>

            <div className="timeline-item">
              <div className="icon-circle">
                <TelephoneOutbound />
              </div>
              <div className="timeline-content">
                <h5>Outbound Operational Services</h5>
                <p>
                  We employ street-smart professionals to enhance the ROI of
                  your sales & lead generation process.
                </p>
              </div>
            </div>

            <div className="timeline-line"></div>

            <div className="timeline-item">
              <div className="icon-circle">
                <Envelope />
              </div>
              <div className="timeline-content">
                <h5>Email + Chat Support</h5>
                <p>
                  We offer email and chat support services that provide quick
                  and efficient communication between you and your customers.
                </p>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default Section4;
